import { Reducer } from 'redux';
import _ from 'lodash';
import { IReduxAction } from 'app/types/actions';
import { CartActionTypes as types, ICartState } from './types';

const initialState: ICartState = {
  cartType: undefined,

  minAmount: 0,
  totalAmount: 0,
  totalRawAmount: 0,
  totalQuantity: 0,
  lineItems: {},
  defaultLineItems: {},
};

const calculateTotalAmount = (lineItems) => _.sum(_.map(lineItems, (item) => item.amount * item.quantity));
const calculateTotalQuantity = (lineItems) => _.sum(_.map(lineItems, (item) => item.quantity));

const reducer: Reducer<ICartState> = (
  state = initialState,
  action: IReduxAction,
): ICartState => {
  switch (action.type) {
    case types.RESET_CART: {
      return {
        ...initialState,
        ...action.payload,
      };
    }
    case types.UPDATE_CART: {
      const totalAmount = calculateTotalAmount(action.payload.lineItems);
      const calculatedTotalAmount = totalAmount < action.payload.minAmount
        ? action.payload.minAmount
        : totalAmount;

      return {
        ...state,
        ...action.payload,
        minAmount: action.payload.minAmount,
        totalRawAmount: totalAmount,
        totalAmount: calculatedTotalAmount,
        totalQuantity: calculateTotalQuantity(action.payload.lineItems),
      };
    }
    default:
      return state;
  }
};

export default reducer;
